import { useSubscription } from "@apollo/client";
import { Table } from "antd";
import { useState, useEffect } from "react";

import { EdgeLogsDocument } from "@src/graphql/graphql";

import { parseLog } from "./utils";

interface EdgeLogsTableProps {
  assetId: string;
}

const columns = [
  {
    title: "#",
    dataIndex: "number",
    key: "number",
  },
  {
    title: "Time",
    dataIndex: "time",
    key: "time",
  },
  {
    title: "Level",
    dataIndex: "level",
    key: "level",
  },
  {
    title: "Message",
    dataIndex: "message",
    key: "message",
  },
  {
    title: "Raw",
    dataIndex: "raw",
    key: "raw",
  },
];

const EdgeLogsTable = ({ assetId }: EdgeLogsTableProps) => {
  const [edgeLogs, setEdgeLogs] = useState<string[]>([]);

  const { data } = useSubscription(EdgeLogsDocument, {
    variables: { assetId },
  });

  useEffect(() => {
    const edgeLog = data?.edgeLogs;
    if (edgeLog) {
      setEdgeLogs((prevEdgeLogs) => [...prevEdgeLogs, edgeLog]);
    }
  }, [data]);

  const dataSource = edgeLogs.map((log, index) => parseLog(log, index));

  return (
    <Table
      size="small"
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

export default EdgeLogsTable;
